<div mat-dialog-title>
  <span>{{ 'CHANGELOG.CREATE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content>
  <form [formGroup]="form" #formTemplate="ngForm" class="changelog-form">
    <q9-text-field
      formControlName="manualRecord"
      [label]="'CHANGELOG.MANUAL' | translate"></q9-text-field>
    <q9-text-field formControlName="author" [label]="'ASIDE_R.AUTHOR' | translate"></q9-text-field>
    <q9-textarea-field
      formControlName="description"
      [label]="'CHANGELOG.DESCR' | translate"
      [minRows]="3"
      [maxRows]="10"></q9-textarea-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>
  <q9-primary-button [isLoading]="isSubmitted" (click)="formTemplate.onSubmit($event); onSubmit()">
    {{ 'CHANGELOG.CREATE_BTN' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
